"use strict";

var _construct = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsDescriptor = void 0;

var Tag_1 = require("./Tag");
/**
 * Represents a composition of region tags
 */


var TagsDescriptor = /*#__PURE__*/function () {
  /**
   * Creates a new `TagDescriptor` object with specified tags
   * @param primaryTag - Primary `Tag` for the descriptor
   * @param secondaryTags - An array of secondary tags (optional)
   */
  function TagsDescriptor(arg1) {
    var arg2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, TagsDescriptor);

    // empty TagsDescriptor
    if (arg1 === undefined) {
      this.primaryTag = null;
      this.allTags = [];
    } else if (arg1 instanceof Tag_1.Tag) {
      // arg1 = primaryTag, arg2 = secondaryTag
      if (arg2 instanceof Array) {
        this.allTags = _construct(Array, [arg1].concat(_toConsumableArray(arg2)));
      } else {
        this.allTags = [arg1];
      }

      this.primaryTag = arg1;
    } else if (arg1 instanceof Array) {
      // arg1 = tags, ignore arg2
      this.allTags = arg1.map(function (tag) {
        return tag.copy();
      });

      if (arg1.length > 0) {
        this.primaryTag = arg1[0];
      } else {
        this.primaryTag = null;
      }
    } else if (arg1 === null) {
      // arg1 = null | undefined, ignore
      if (arg2 instanceof Array) {
        this.allTags = arg2.map(function (tag) {
          return tag.copy();
        });
      } else {
        this.allTags = [];
      }

      this.primaryTag = null;
    }
  }
  /**
   * Creates a new `TagDescriptor` object based on extracting specific properties from any provided object
   * @remarks The `TagDescriptor` object is *immutable*. All public properties return copies of objects.
   * @param data - An `ITagDescriptor` object with the `primary` and `secondary`
   * properties implementing `ITag` and `ITag[]` interfaces
   * @returns A new `TagDescriptor` object
   */


  _createClass(TagsDescriptor, [{
    key: "toString",

    /**
     * Returns a string with a comma separated list of tags with primary tag first (if present)
     */
    value: function toString() {
      var str = "";

      if (this.primaryTag !== null) {
        str += this.primaryTag.name;
        this.secondary.forEach(function (tag) {
          str += ", " + tag.name;
        });
      } else {
        this.secondary.forEach(function (tag) {
          str += ", " + tag.name;
        });
        str = str.substring(2, str.length);
      }

      return str;
    }
    /**
     * Returns an `ITagsDescriptor` object with `primary` and `secondary` properties
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      if (this.primaryTag !== null) {
        return {
          primary: this.primaryTag.toJSON(),
          secondary: this.secondary.map(function (tag) {
            return tag.toJSON();
          })
        };
      } else {
        return {
          primary: null,
          secondary: this.secondary.map(function (tag) {
            return tag.toJSON();
          })
        };
      }
    }
  }, {
    key: "all",

    /**
     * Returns an array of all tags (no order guaranteed). *Readonly*
     */
    get: function get() {
      return this.allTags.map(function (tag) {
        return tag.copy();
      });
    }
    /**
     * Returns the primary tag. *Readonly*
     */

  }, {
    key: "primary",
    get: function get() {
      if (this.primaryTag !== null) {
        return this.primaryTag.copy();
      } else {
        return null;
      }
    }
    /**
     * Returns an array of all secondary tags (no order guaranteed). *Readonly*
     */

  }, {
    key: "secondary",
    get: function get() {
      var _this = this;

      if (this.primaryTag !== null) {
        return this.all.filter(function (tag) {
          return tag.name !== _this.primary.name;
        });
      } else {
        return this.all;
      }
    }
  }], [{
    key: "BuildFromJSON",
    value: function BuildFromJSON(data) {
      var p = null;

      if (data.primary !== null && data.primary !== undefined) {
        p = Tag_1.Tag.BuildFromJSON(data.primary);
      }

      var s = data.secondary === undefined ? [] : data.secondary.map(function (tag) {
        return Tag_1.Tag.BuildFromJSON(tag);
      });
      return new TagsDescriptor(p, s);
    }
  }]);

  return TagsDescriptor;
}();

exports.TagsDescriptor = TagsDescriptor;